import React, { useEffect, useState } from 'react'
import { eventsApi, EventItem, Paginated } from '../../../shared/api/events'

const EventsPage: React.FC = () => {
  const [data, setData] = useState<Paginated<EventItem> | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let mounted = true
    setLoading(true)
    eventsApi
      .list(1, 10)
      .then((res) => {
        if (mounted) {
          setData(res)
          setError(null)
        }
      })
      .catch((err) => {
        setError(err?.message || '加载失败')
      })
      .finally(() => setLoading(false))
    return () => {
      mounted = false
    }
  }, [])

  if (loading) return <div className="p-4 text-gray-600">加载中...</div>
  if (error) return <div className="p-4 text-red-600">{error}</div>
  if (!data || data.items.length === 0) return <div className="p-4 text-gray-600">暂无赛事</div>

  return (
    <div className="p-4">
      <h1 className="text-xl font-semibold mb-4">赛事列表</h1>
      <ul className="space-y-3">
        {data.items.map((e) => (
          <li key={e.id} className="p-3 border rounded">
            <div className="font-medium">{e.name}</div>
            <div className="text-sm text-gray-500">{e.location} · {e.date}</div>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default EventsPage

